<template>
    <a-card>
        <div class="title">
            <h3>消息通知</h3>
        </div>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #receiveStatus="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['receiveStatus']" :text="text"></dict-render>
                </a-tag>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onDetail(record)">详情</a>
                </div>
            </template>

        </a-table>
    </a-card>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>

</template>

<script>
import {notificationApi} from "@/api/innovationService";
import {tableListMixin,dictMixin} from "@/mixins";
import DictRender from "@/components/other/DictRender";
import {defaultDateCustomRender} from "@/utils/customRender";
import Detail from "./components/Detail"

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "消息标题", dataIndex: "title", key: "title"},
    {title: "发布时间", dataIndex: "publishTime", key: "publishTime", customRender: defaultDateCustomRender},
    {title: "状态", dataIndex: "receiveStatus", key: "receiveStatus",slots:{customRender: "receiveStatus"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},

];
export default {
    name: "index",
    mixins: [tableListMixin,dictMixin],
    components: {
        DictRender,Detail
    },
    data() {
        return {
            dictNames: 'receiveStatus',
            columns,
            queryParamFixed: {
                id:this.$ls.get("notificationId")
            },
            listKeyField: "id",
            listUrl:notificationApi.pageList
        }
    },
    mounted() {
    },
    methods: {
        onCloseModel(){
            this.loadData(1)
        },
        onDetail(record){
            this.getAction({
                url:notificationApi.detail,
                params:{
                    id:record.id,
                    noticeId:record.noticeId
                }
            }).then(res=>{
                console.log(res,'res')
                this.onShowModal("detailmodal",res)
            })
        }
    }
}
</script>

<style scoped lang="less">
.title {
    border-bottom: 4px solid #000000;
    margin-bottom: 20px;
h3 {
    font-weight: bold;
}
}
</style>
